import { FC, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import matchAll from 'string.prototype.matchall';
import useGetHsePage from "../../shared/hooks/useGetHsePage";
import { createGlobalStyle } from "styled-components";
export interface HsePage {
    status: string;
    page_html: string;
}

export interface HsePageScraperControllerProps<HsePage> {
    onHsePageLoaded?: (page: HsePage) => void;
    id: string;
    lang?: string;
    url?: string;
}

const GlobalNonePaddingBottom = createGlobalStyle`
    .app-content {
        padding-bottom: 0!important;
    }
`

const ScopedStylesheet = createGlobalStyle<{ id: string, css: string }>`
    .hse-scope-${(props) => props.id} {
        ${props => props.css}
    }
`

const NONE_PADDING_BOTTOM_IDS = ['3924', '4881', '4964']

export const HsePageScraperController: FC<HsePageScraperControllerProps<HsePage>> = (props) => {
    const { onHsePageLoaded, id, lang, url } = props;
    const ref = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const [stylesSheets, setStylesSheets] = useState<string[]>([]);
    const [hsePage, isHsePageLoading] = useGetHsePage(
        id, lang, url
    );
    const include = (url: string) => {
        return new Promise<{ script: HTMLScriptElement }>((resolve) => {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.onload = function () {
                resolve({ script });
            };
            document.getElementsByTagName('body')[0].appendChild(script);
        });
    }

    // Отслеживать изменения
    useEffect(() => {
        onHsePageLoaded?.(hsePage ? hsePage : false);
        if (hsePage && hsePage.html) {
            const scripts = ref.current?.querySelectorAll('script');
            
            scripts?.forEach(script => {
                const src = script.getAttribute('src');
                if (src) {
                    include(src);
                }
            });

            const stylesheets = ref.current?.querySelectorAll('[rel="stylesheet"]');
            stylesheets?.forEach(stylesheet => {
                const href = stylesheet.getAttribute('href');
                fetch(href).then(res => res.text()).then(text => {
                    setStylesSheets(prev => [...prev, text]);
                    // ref.current?.removeChild(stylesheet);
                });
            });
        }
    }, [hsePage, onHsePageLoaded]);

    useEffect(() => {
        if (hsePage?.html && location.hash) {
            const hash = location.hash.slice(1);
            setTimeout(() => {
                const element = document.getElementById(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, [hsePage, location.hash]);

    return (
        <div>
            {NONE_PADDING_BOTTOM_IDS.includes(id) && <GlobalNonePaddingBottom />}
            {<div
                ref={ref}
                className={`hse-scope-${id}`}
                dangerouslySetInnerHTML={{ __html: hsePage?.html }}
            />}
            {stylesSheets.map(css => <ScopedStylesheet id={id} css={css} />)}
        </div>
    );
};

export default HsePageScraperControllerimport { FC, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import matchAll from 'string.prototype.matchall';
import useGetHsePage from "../../shared/hooks/useGetHsePage";
import { createGlobalStyle } from "styled-components";
export interface HsePage {
    status: string;
    page_html: string;
}

export interface HsePageScraperControllerProps<HsePage> {
    onHsePageLoaded?: (page: HsePage) => void;
    id: string;
    lang?: string;
    url?: string;
}

const GlobalNonePaddingBottom = createGlobalStyle`
    .app-content {
        padding-bottom: 0!important;
    }
`

const ScopedStylesheet = createGlobalStyle<{ id: string, css: string }>`
    .hse-scope-${(props) => props.id} {
        ${props => props.css}
    }
`

const NONE_PADDING_BOTTOM_IDS = ['3924', '4881', '4964']

export const HsePageScraperController: FC<HsePageScraperControllerProps<HsePage>> = (props) => {
    const { onHsePageLoaded, id, lang, url } = props;
    const ref = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const [stylesSheets, setStylesSheets] = useState<string[]>([]);
    const [hsePage, isHsePageLoading] = useGetHsePage(
        id, lang, url
    );
    const include = (url: string) => {
        return new Promise<{ script: HTMLScriptElement }>((resolve) => {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.onload = function () {
                resolve({ script });
            };
            document.getElementsByTagName('body')[0].appendChild(script);
        });
    }

    // Отслеживать изменения
    useEffect(() => {
        onHsePageLoaded?.(hsePage ? hsePage : false);
        if (hsePage && hsePage.html) {
            const scripts = ref.current?.querySelectorAll('script');
            
            scripts?.forEach(script => {
                const src = script.getAttribute('src');
                if (src) {
                    include(src);
                }
            });

            const stylesheets = ref.current?.querySelectorAll('[rel="stylesheet"]');
            stylesheets?.forEach(stylesheet => {
                const href = stylesheet.getAttribute('href');
                fetch(href).then(res => res.text()).then(text => {
                    setStylesSheets(prev => [...prev, text]);
                    // ref.current?.removeChild(stylesheet);
                });
            });
        }
    }, [hsePage, onHsePageLoaded]);

    useEffect(() => {
        if (hsePage?.html && location.hash) {
            const hash = location.hash.slice(1);
            setTimeout(() => {
                const element = document.getElementById(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, [hsePage, location.hash]);

    return (
        <div>
            {NONE_PADDING_BOTTOM_IDS.includes(id) && <GlobalNonePaddingBottom />}
            {<div
                ref={ref}
                className={`hse-scope-${id}`}
                dangerouslySetInnerHTML={{ __html: hsePage?.html }}
            />}
            {stylesSheets.map(css => <ScopedStylesheet id={id} css={css} />)}
        </div>
    );
};

export default HsePageScraperController